const initState = {
  request: [],
  response: [],
  responseError: false
};
  
  export default initState;
  